var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart elevation-3"},[_c('h5',{staticClass:"chart-title"},[_vm._v("Monthly Views")]),_c('div',{staticClass:"chart-container"},[_c('line-chart',{attrs:{"chart-data":_vm.datacollection,"options":_vm.options}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }